import ProjectConfig from './ProjectConfig'

export default ProjectConfig
